"use client";

import AuthFooter from "@/components/common/AuthFooter";
import AuthForm from "@/components/ui/AuthForm";
import Card from "@/components/ui/Card";
import ErrorText from "@/components/ui/ErrorText";
import Heading from "@/components/ui/Heading";
import { Loading } from "@/components/ui/Loading";
import { dashboardTitle, explainMovieUrl, signinDescription } from "@/constants";
import { useAuthContext } from "@/contexts/AuthContext";
import { auth, handleFirebaseError } from "@/firebase";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useRouter } from "next/navigation";
import { useState } from "react";

export default function SignIn() {
  const [submitProcessing, setSubmitProcessing] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const router = useRouter();
  const { user, isLoading } = useAuthContext();

  const handleSignIn = async (e: React.FormEvent) => {
    e.preventDefault();
    if (submitProcessing) return;
    setSubmitProcessing(true);

    setError(null); // エラーメッセージをリセット

    try {
      await signInWithEmailAndPassword(auth, email, password);
      router.push("/dashboard");
    } catch (error) {
      const errMsg = handleFirebaseError(
        error,
        "ログインに失敗しました。メールアドレスとパスワードを確認してください。"
      );
      setError(errMsg);
      console.error(error);
    }
    setSubmitProcessing(false);
  };

  if (isLoading) {
    return <Loading />;
  }

  if (user) {
    router.push("/");
  }

  return (
    <div>
      <div className="flex items-start justify-center">
        <div className="w-full max-w-md">
          {explainMovieUrl && (
            <div className="w-full h-56 bg-gray-300 flex items-center justify-center rounded shadow">
              <iframe
                className="w-full h-full"
                src={explainMovieUrl}
                title="YouTube video player"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          )}
          <h3
            className={`text-center text-base font-bold mb-8 whitespace-pre-line ${
              explainMovieUrl ? "my-2" : "mt-6"
            }`}
          >
            {dashboardTitle}
          </h3>
          <Heading level="h5" centered className="text-xs mx-5 my-1 whitespace-pre-line">
            {signinDescription}
          </Heading>
        </div>
      </div>
      <div className="p-3 flex flex-col items-center justify-center">
        <Card className="w-full max-w-md px-6 py-4">
          <ErrorText>{error}</ErrorText>
          <AuthForm
            fields={[
              {
                name: "email",
                value: email,
                onChange: (e) => setEmail(e.target.value),
                placeholder: "メールアドレス",
                required: true,
              },
              {
                name: "password",
                value: password,
                onChange: (e) => setPassword(e.target.value),
                placeholder: "パスワード",
                required: true,
              },
            ]}
            onSubmit={handleSignIn}
            submitLabel="ログイン"
            disabled={submitProcessing}
          />
        </Card>
        <div className="w-full max-w-md mt-4">
          <AuthFooter showSignIn={false} />
        </div>
      </div>
    </div>
  );
}
